export const deviceIdNameMap = {
  "2b5990bd-1949-454d-9372-c1b891522cb7": "Gartnerløkka",
};
